import {
  ElementType,
  HtmlHTMLAttributes,
  PropsWithChildren,
  ReactNode,
} from 'react';
import { cn } from '@sib/ui';
import { NoResults } from '@sib/ui/icons';

export interface NoTableDataProps
  extends PropsWithChildren,
    HtmlHTMLAttributes<HTMLDivElement> {
  Icon?: ElementType;
  title: string;
  description?: string;
  actions?: ReactNode;
}

export const NoTableData = ({
  Icon,
  title,
  description,
  children,
  className,
  actions,
}: NoTableDataProps) => (
  <div className="flex size-full items-center justify-center overflow-hidden rounded">
    <div
      className={cn(
        'relative box-border flex size-full flex-col items-center justify-center gap-y-7 rounded-sm py-20',
        className
      )}
    >
      {Icon ? (
        <Icon className="text-primary size-32" />
      ) : (
        <NoResults className="text-primary size-32" aria-hidden="true" />
      )}
      <div className="flex w-full flex-col items-center gap-y-4">
        <h3 className="text-primary text-center text-3xl">{title}</h3>
        {description && (
          <p className="text-primary max-w-md text-center text-xl font-normal">
            {description}
          </p>
        )}
      </div>
      {actions && <div className="mt-4">{actions}</div>}
      {children}
    </div>
  </div>
);
